import { atom } from "jotai";

import { currentModalStepAtom } from "../../stores";

export const enterEditableRoundsStepAtom = atom(
  null,
  (get, set, payload?: null) => {
    set(currentModalStepAtom, { type: "EditRounds" });
  }
);
